import { localDatabaseUrls } from "../backend/constants";
import { getAPI } from "../backend/commons";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import AlertManager from "../shared/Alert/Alert";

export const getLandedCostSkuExclusionHistory = async () => {
  const tokenInfo = await getJWTToken();
  if (!tokenInfo) {
    window.location.href = "/";
    return [];
  }

  const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.landedCostSkuExclusionHistory}`;

  try {
    const response = await getAPI(apiUrl, tokenInfo);
    if (response?.status === 200) {
      return response.json();
    }
    const error = await response?.json?.().catch(() => ({}));
    throw new Error(
      error?.message || "Unable to load landed cost SKU exclusion history."
    );
  } catch (error) {
    AlertManager.error(
      error?.message || "Unable to load landed cost SKU exclusion history."
    );
    return [];
  }
};

export default getLandedCostSkuExclusionHistory;
